import {
  showDocumentModalRoutine,
  showHowItWorksModalRoutine,
  bookACallModalRoutine,
  SHOW_DOCUMENT_MODAL_CLEANUP,
  SHOW_HOW_IT_WORKS_MODAL_CLEANUP,
  BOOK_A_CALL_MODAL_CLEANUP
} from './routines'

export default {
  [showDocumentModalRoutine.TRIGGER](state, payload) {
    state.showDocumentModal = payload
  },
  [showHowItWorksModalRoutine.TRIGGER](state, payload) {
    state.showHowItWorksModal = payload
  },
  [bookACallModalRoutine.TRIGGER](state, payload) {
    state.bookACallModalSeen = payload
  },
  [SHOW_DOCUMENT_MODAL_CLEANUP](state, payload) {
    Object.assign(state, payload)
  },

  [SHOW_HOW_IT_WORKS_MODAL_CLEANUP](state, payload) {
    Object.assign(state, payload)
  },
  [BOOK_A_CALL_MODAL_CLEANUP](state, payload) {
    Object.assign(state, payload)
  }
}
